module.exports = __webpack_public_path__ + "img/1c2b996.png";